module.exports = __webpack_public_path__ + "@/assets/img/zip.1362bd54.svg";